import { render, staticRenderFns } from "./NodeContent.vue?vue&type=template&id=02490f10&scoped=true"
import script from "./NodeContent.vue?vue&type=script&lang=js"
export * from "./NodeContent.vue?vue&type=script&lang=js"
import style0 from "./NodeContent.styl?vue&type=style&index=0&id=02490f10&scoped=true&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02490f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02490f10')) {
      api.createRecord('02490f10', component.options)
    } else {
      api.reload('02490f10', component.options)
    }
    module.hot.accept("./NodeContent.vue?vue&type=template&id=02490f10&scoped=true", function () {
      api.rerender('02490f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleFlow/src/components/NodeContent.vue"
export default component.exports